import { isEmpty } from "lodash-es"

import { IUser } from "@/api/app/types/user"
import AppConfig from "@/config/app"
import stores from "@/stores"

export function initIntercom({
  id,
  shop,
  email,
  shop_owner,
  created_at,
  shopify_plan,
  rating,
  is_cross_sell,
}: IUser) {
  const fromApp =
    "Return" + (AppConfig.env !== "production" ? `_${AppConfig.env}` : "")

  // 用户 id 环境变量判断
  const USER_ID_PREFIX =
    "return" + (AppConfig.env !== "production" ? `_${AppConfig.env}` : "")

  window.Intercom("onShow", () => {
    stores.CommonStore.setPostShow(false)
  })

  console.group("初始化 Intercom")
  if (id > 0 && !isEmpty(email)) {
    console.log("正在初始化 intercom")
    window.Intercom("boot", {
      app_id: "t6tndyrj",
      created_at,
      email,
      from_app: fromApp,
      name: shop_owner || shop || "no name",
      review: rating === 0 ? "no review" : `${rating}-star`,
      shop_name: shop,
      shopify_store_version: shopify_plan?.displayName || "Unknown", // Shopify 店铺版本
      userId: `${USER_ID_PREFIX}_${id}`,
      user_id: `${USER_ID_PREFIX}_${id}`,
      "cross-sell_target_customer": is_cross_sell,
    })
  } else {
    console.log("必要信息不存在，不加载 Intercom")
    window.Intercom("boot", {
      app_id: "t6tndyrj",
    })
  }
  // 添加onShow事件 并隐藏掉post引导弹窗

  console.groupEnd()
}

export function addCss(str_css: string) {
  try {
    // IE下可行
    // @ts-ignore
    const style = document.createStyleSheet()

    style.cssText = str_css
  } catch (e) {
    // Firefox,Opera,Safari,Chrome下可行
    const style = document.createElement("style")

    style.type = "text/css"
    style.textContent = str_css
    // @ts-ignore
    document.getElementsByTagName("HEAD").item(0).appendChild(style)
  }
}
